export const removeFromParent = <T extends HTMLElement>(node: T): T => {
  if (node.parentNode) {
    node.parentNode.removeChild(node);
  }
  return node;
};